<template>
        <v-layout wrap align-center justify-center>

            <v-flex xs12 text-center text-sm-right py-3>
                <v-chip small outlined color="accent" v-if="internal === true">
                    <v-icon class="mr-2" size="16">fas fa-clock</v-icon>
                    sobre cupo
                </v-chip>
                <v-chip small outlined color="secondary" class="ml-1">
                        <v-icon class="mr-2" size="16">fas fa-clock</v-icon>
                        disponible
                </v-chip>
                <v-chip small outlined class="ml-1">
                    <v-icon class="mr-2"  size="16">fas fa-user-lock</v-icon>
                    reservado
                </v-chip>
            </v-flex>

            <v-flex xs12>

                <div class="dates-container" >
                    <template v-if="loadingEvents">
                        cargando...
                    </template>
                    <template v-else>
                        <template v-if="events.length === 0">
                            <h3 class="subtitle font-weight-light text-center mt-4">No se han creado bloques aun</h3>
                        </template>
                        <div class="date-item " v-for="(events, date) in eventsMap" :key="date">
                            <h3 class="subtitle font-weight-light">{{$moment(date).format('ddd D MMMM').toUpperCase()}}</h3>
                            <div class="py-1 mb-3">
                                <template v-for="(event, index) in events">
                                <span :key="event.key">
                                    <v-btn
                                            transition="scroll-y-transition"
                                            class="ma-1"
                                            :color="event.extra ? 'accent' :  'secondary'"
                                            depressed
                                            :outlined="!event.selected"
                                            small
                                            @click="onSelect(event)"
                                            :disabled="event.locked || Boolean(!internal && event.extra)">
                                        <v-icon size="18" class="mr-1" v-if="event.locked" >fas fa-user-lock</v-icon>
                                        <v-icon size="18" class="mr-1" v-else>fas fa-clock</v-icon>
                                        {{event.time}}
                                    </v-btn>
                                    <div
                                            @click="addExtraEvent(event.nextExtraEvent, date)"
                                            :class="['extra-block-btn', {'loading': creatingExtraEvent === event.nextExtraEvent.event}]"
                                            :disabled="creatingExtraEvent === event.nextExtraEvent.event"
                                            v-if="internal && event.nextExtraEvent">
                                            <div class="pin"></div>
                                            <div class="extra-block-label">
                                                <span v-if="creatingExtraEvent === event.nextExtraEvent.event">Creando...</span>
                                                <span v-else>
                                                    sobre cupo
                                                ({{event.nextExtraEvent.time}})
                                                </span>
                                            </div>
                                    </div>
                                </span>

                                </template>
                            </div>
                            <v-divider class="my-1"></v-divider>
                        </div>
                    </template>
                </div>
            </v-flex>
        </v-layout>
</template>
<script>

    import {mapMutations, mapState} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {md5} from "@/utils/Hash";
    import {whisperOnPrivate, listenPrivateWhisper, leaveChannel} from '@/utils/Sockets'

    export default{
        components: {        },
        props: ['schedule', 'lockedEvents', 'selected', 'height', 'internal', 'defaultAppointment'],
        data(){

            return {
                creatingExtraEvent: null,
                showAlertFirstTime: false,
                scheduleId: null,
                calMenu: false,
                locked: false,
                locking: null,
                reload: true,
                loadingEvents: false,
                events: [],
                connectedToSocket: false
            }
        },
        created(){
            var vm = this
            vm.scheduleId = vm.$route.params.id
        },
        mounted(){
            var vm = this
            vm.connectSocket()

        },
        beforeDestroy(){
            const vm = this
            vm.disconnectSocket()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            connectSocket(){
              const vm = this
              if(!vm.whisperRoom || vm.connectedToSocket) return
              console.log('connecting to socket', vm.whisperRoom)
              listenPrivateWhisper(vm.whisperRoom, 'extraEventCreated', vm.onExtraEventReceived)
              vm.connectedToSocket = true
            },
            disconnectSocket(){
              const vm = this
              leaveChannel(vm.whisperRoom)
              vm.connectedToSocket = false
            },
            onExtraEventReceived({event}){
                const vm = this
                vm.events.push(event)
            },
            async getEvents(setLoadingStatus = true, cb = () => {}){
                var vm = this
                if(!vm.schedule) return

                if(setLoadingStatus) vm.loadingEvents = true
                const url = vm.internal ? `schedule/${vm.schedule.id}/events/` : `public/schedule/${vm.schedule.id}/events/`
                const response = await ApiUtils.makeGet(url)
                if(setLoadingStatus) vm.loadingEvents = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error cargando bloques')
                    return
                }

                const json = await response.json()
                vm.events = json.result.events
                vm.$nextTick(function(){
                    cb()
                })

            },
            async addExtraEvent(extraEventData, date){
                var vm = this

                if(vm.creatingExtraEvent) return

                vm.creatingExtraEvent = extraEventData.event

                let evt = {
                  id: md5(`${vm.schedule.id} ${extraEventData.date} ${extraEventData.time}`),
                  date: date,
                  time: extraEventData.time,
                  extra: true
                }

                setTimeout(function(){
                  vm.events.push(evt)
                  whisperOnPrivate(vm.whisperRoom, 'extraEventCreated', {event: evt})
                  vm.$emit('select', evt)
                  vm.creatingExtraEvent = null
                }, 1000)


                /*const response = await ApiUtils.makePost('schedules/events/extra', {
                    event_id: extraEventData.event,
                    time: extraEventData.time
                })

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error creando sobre cupo')
                    vm.creatingExtraEvent =null
                    return
                }

                vm.getEvents(false, async () => {
                    const json = await response.json()
                    vm.$emit('select', json.result.extra_event)
                    vm.creatingExtraEvent =null
                })*/

            },
            onSelect(event){
                this.$emit('select', event)
            },
            getRandomKey(){
                return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            },
            setDefaultAppointment(){
              const vm = this
              if(!vm.events || vm.events.length === 0) return
              console.log('default appointment ? ', vm.defaultAppointment)
              const scheduleId = vm.defaultAppointment && vm.defaultAppointment.schedule && vm.defaultAppointment.schedule.id || (vm.defaultAppointment && vm.defaultAppointment.schedule_id || null)
              if(vm.defaultAppointment && scheduleId === vm.schedule.id){
                let {date: defaultDate, time: defaultTime} = vm.defaultAppointment
                let partsCount = defaultTime.split(':')
                if(partsCount.length === 2){
                  defaultTime = `${defaultTime}:00`
                }

                console.log('searching appointment:', defaultDate, defaultTime)

                const found = vm.events.find(evt => {
                  let {date, time} = evt
                  let partsCount = time.split(':')
                  if(partsCount.length === 2){
                    time = `${time}:00`
                  }
                  return date === defaultDate
                      && time === defaultTime
                })

                console.log('event found', found)

                if(found && !found.locked){
                  vm.$emit('select', found)
                }

                if(found && found.locked){
                  vm.showSnackBar(`La hora de las ${found.time} ha sido reservada por alguien mas`)
                }

              }

            }
        },
        computed: {
            ...mapState(['currentProvider', 'currentUser']),
            mergedLockedEvents(){
              const vm = this
              return [
                  ...vm.lockedEvents,
                  ...vm.events.filter(evt => evt.reserved).map(evt => evt.id)
              ]
            },
            whisperRoom(){
              const vm = this
              if(!vm.schedule) return ''
              return `schedule.${vm.schedule.id}.appointments.extra`

            },
            eventsMap(){
                var vm = this

                if(!vm.schedule || !vm.events || vm.events.length === 0) return []

                const dates = vm.events.slice().map(event => event.date)
                const distinctDates = [...new Set(dates)]
                        .sort((a,b) => vm.$moment(a) - vm.$moment(b))

                var eventsMap = {}
                for (var date of distinctDates){

                    eventsMap[date] = vm.events.slice()
                            .filter(evt => evt.date === date)
                            .map(evt => {
                                evt.time = vm.$moment(evt.time, 'HH:mm').format('HH:mm')
                                return evt
                            })

                    eventsMap[date] = eventsMap[date].sort((a,b) => {
                        return vm.$moment(`${a.date} ${a.time}`) - vm.$moment(`${b.date} ${b.time}`)
                    })

                    for(let i in eventsMap[date]){

                      const key = vm.getRandomKey()
                      const extraKey = vm.getRandomKey()

                      var evt =  eventsMap[date][i]
                      eventsMap[date][i]['locked'] = vm.mergedLockedEvents.find(locked => {
                        return locked === evt.id
                      }) !== undefined || !!evt.client

                      eventsMap[date][i]['selected'] = vm.selected && vm.selected.id === evt.id

                      const currentBlock = vm.$moment(evt.time, 'HH:mm')
                      const nextEvent = eventsMap[date][Number(i)+1]

                      var duration =   nextEvent ?
                          vm.$moment(nextEvent.time, 'HH:mm').diff(currentBlock, 'minutes') : null

                      const interval =duration || vm.schedule.interval_minutes
                      const nextBlock = currentBlock.add(Math.round(interval / 2), 'minutes')

                      eventsMap[date][i]['nextExtraEvent'] = {
                        key: extraKey,
                        event: evt.id,
                        time: nextBlock.format('HH:mm')
                      }

                      eventsMap[date][i]['key'] = key

                    }

                }

                return eventsMap

            }
        },
        watch: {
            whisperRoom(val){
              if(val){
                this.connectSocket()
              }
            },
            locked(val){
                var vm = this
            },
            date(val){

            },
            schedule(val){
              console.log('schedule changed!')
              const vm = this
                if(val){
                  vm.getEvents()
                  vm.disconnectSocket()
                  vm.$nextTick(function(){
                    vm.connectSocket()
                  })
                }
            },
          defaultAppointment(){
              const vm = this
              vm.setDefaultAppointment()
          },
            events(evts){
                var vm = this
                vm.setDefaultAppointment()
            }
        }
    }
</script>

<style scoped>


    .extra-block-btn{
        display: inline;
        padding: 8px;
        position: relative;
        cursor: pointer;
    }

    .extra-block-btn .pin{
        opacity: 0;
        transform: scale(.1);
        position: absolute;
        top: -5px;
        left: 35%;
        width: 30%;
        height: 110%;
        border-radius: 0 0 10px 10px;
        background-color: #6757ff;
        transition: .1s all;
    }

    .extra-block-label{
        pointer-events: none;
        opacity: 0;
        transform: scale(.1);
        position: absolute;
        text-transform: uppercase;
        font-size: 11px;
        border-radius: 5px;
        padding: 4px;
        width: 95px;
        left: -40px;
        top: -45px;
        text-align: center;
        color: #fff;
        background-color: #6757ff;
        transition: .1s all;
        transition-delay: .05s;
    }

    .extra-block-btn:hover .pin{
        opacity: 1;
        transform: scale(1)
    }

    .extra-block-btn:hover .extra-block-label{
        opacity: 1;
        transform: scale(1);
        background-color: #6757ff;
    }

    .extra-block-btn.loading .pin{
        opacity: 1;
        transform: scale(1.1);
        background-color: #e91e63 ;
        top: -20px;
        height: 5%
    }

    .extra-block-btn.loading .extra-block-label{
        opacity: 1;
        transform: scale(1.1);
        top: -25px;
        background-color: #e91e63 ;
        border-radius: 30px;
    }

    .dates-container{
        position: relative;
        max-width: 1200px;
        width: 100%;
        overflow: auto;
    }

    .date-item{
        padding: 10px;
        margin: 5px;
        border-radius: 5px
    }
</style>
